import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule, routingComponents } from './app-routing.module';
import { FormsModule } from '@angular/forms';
//components
import { AppComponent } from './app.component';
//directives
import { HideIfUnauthorizedDirective } from './directives/hideIfUnauthorized.directive';
import { SelectRequiredValidatorDirective } from './directives/select-required-validator.directive';
import { XtenderComponent } from './components/xtender/xtender.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from "@angular/material/icon"; 
import { FileUploadService } from './services/file-upload.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatExpansionModule } from '@angular/material/expansion';
import { HttpResponseInterceptor } from './services/authInterceptor';


@NgModule({ declarations: [
        AppComponent,
        HideIfUnauthorizedDirective,
        routingComponents,
        SelectRequiredValidatorDirective,
        XtenderComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        BrowserAnimationsModule,
        MatInputModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatDialogModule,
        MatSelectModule,
        MatFormFieldModule,
        MatExpansionModule],
    providers: [
        FileUploadService,
        { provide: HTTP_INTERCEPTORS, useClass: HttpResponseInterceptor, multi: true },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule { }
